var _dec, _dec2, _dec3, _class, _RadioInput;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { testable } from '@instructure/ui-testable';
import { omitProps, withDeterministicId } from '@instructure/ui-react-utils';
import { isActiveElement } from '@instructure/ui-dom-utils';
import { withStyle } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { allowedProps, propTypes } from './props';

/**
---
category: components
---
**/
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
let RadioInput = (_dec = withDeterministicId(), _dec2 = withStyle(generateStyle, generateComponentTheme), _dec3 = testable(), _dec(_class = _dec2(_class = _dec3(_class = (_RadioInput = class RadioInput extends Component {
  constructor(props) {
    super(props);
    this.ref = null;
    this._defaultId = void 0;
    this._input = null;
    this.handleInputRef = el => {
      this._input = el;
      if (typeof this.props.inputRef === 'function') {
        this.props.inputRef(el);
      }
    };
    this.handleClick = e => {
      if (this.props.disabled || this.props.readOnly) {
        e.preventDefault();
        return;
      }
      if (typeof this.props.onClick === 'function') {
        this.props.onClick(e);
      }
    };
    this.handleChange = e => {
      if (this.props.disabled || this.props.readOnly) {
        e.preventDefault();
        return;
      }
      if (typeof this.props.checked === 'undefined') {
        this.setState({
          checked: !this.state.checked
        });
      }
      if (typeof this.props.onChange === 'function') {
        this.props.onChange(e);
      }
    };
    if (typeof props.checked === 'undefined') {
      this.state = {
        checked: false
      };
    }
    this._defaultId = props.deterministicId();
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props);
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2);
  }
  focus() {
    var _this$_input;
    (_this$_input = this._input) === null || _this$_input === void 0 ? void 0 : _this$_input.focus();
  }
  get id() {
    return this.props.id || this._defaultId;
  }
  get focused() {
    return isActiveElement(this._input);
  }
  get checked() {
    return typeof this.props.checked === 'undefined' ? this.state.checked : this.props.checked;
  }
  render() {
    const _this$props3 = this.props,
      disabled = _this$props3.disabled,
      readOnly = _this$props3.readOnly,
      label = _this$props3.label,
      value = _this$props3.value,
      name = _this$props3.name,
      styles = _this$props3.styles;
    const props = omitProps(this.props, RadioInput.allowedProps);
    return _jsx("div", {
      css: styles === null || styles === void 0 ? void 0 : styles.radioInput,
      ref: el => {
        this.ref = el;
      },
      children: _jsxs("div", {
        css: styles === null || styles === void 0 ? void 0 : styles.container,
        children: [_jsx("input", {
          ...props,
          id: this.id,
          ref: this.handleInputRef,
          value: value,
          name: name,
          checked: this.checked,
          type: "radio",
          css: styles === null || styles === void 0 ? void 0 : styles.input,
          disabled: disabled || readOnly,
          onChange: this.handleChange,
          onClick: this.handleClick
        }), _jsxs("label", {
          css: styles === null || styles === void 0 ? void 0 : styles.control,
          htmlFor: this.id,
          children: [_jsx("span", {
            css: styles === null || styles === void 0 ? void 0 : styles.facade,
            "aria-hidden": "true"
          }), _jsx("span", {
            css: styles === null || styles === void 0 ? void 0 : styles.label,
            children: label
          })]
        })]
      })
    });
  }
}, _RadioInput.displayName = "RadioInput", _RadioInput.componentId = 'RadioInput', _RadioInput.allowedProps = allowedProps, _RadioInput.propTypes = propTypes, _RadioInput.defaultProps = {
  variant: 'simple',
  size: 'medium',
  disabled: false,
  inline: false,
  context: 'success',
  readOnly: false
}, _RadioInput)) || _class) || _class) || _class);
export default RadioInput;
export { RadioInput };